import React, { FunctionComponent } from 'react';
import styles from './chapter.module.scss';

export interface IChapterProps {
  chapterNumber: number;
  chapterTitle: string;
  chapterText: string;
}

export const Chapter: FunctionComponent<IChapterProps> = ({
  chapterNumber,
  chapterText,
  chapterTitle
}) => {
  return (
    <div className={styles.wrapper}>
      <span className={styles.number}>{chapterNumber}</span>
      <div className={styles.content}>
        <span className={styles.title}>{chapterTitle}</span>
        <span className={styles.text}>{chapterText}</span>
      </div>
    </div>
  );
};
